import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import asderLogo from '../../images/asderrLogo.png';
import { getCoreManagementMenuItems } from '../../config/accessControl';

export const ROLE_CONFIGS = {
  kurucu: {
    color: 'var(--role-kurucu)',
    label: 'Kurucu / Admin',
    icon: '⚑',
    sections: [
      {
        title: 'Yönetim', items: [
          { path: '/admin/dashboard', icon: '◈', label: 'Dashboard' },
          { path: '/admin/ogrenciler', icon: '◉', label: 'Öğrenciler' },
          { path: '/admin/ogretmenler', icon: '◎', label: 'Öğretmenler' },
          { path: '/admin/veliler', icon: '◍', label: 'Veliler' },
          { path: '/admin/siniflar', icon: '▤', label: 'Sınıflar' },
          { path: '/admin/kelebek', icon: '🦋', label: 'Sınav Oluştur' },
        ]
      },
      {
        title: 'Akademik', items: [
          { path: '/admin/denemeler', icon: '▦', label: 'Denemeler' },
          { path: '/admin/ogrenci-deneme-analiz', icon: '📈', label: 'Öğrenci Deneme Analiz' },
          { path: '/admin/turkiye-geneli-deneme-sonuclari', icon: '▥', label: 'Türkiye Geneli Deneme Sonuçları' },
          { path: '/admin/ders-programi', icon: '▨', label: 'Ders Programı' },
          { path: '/admin/etut-yonetimi', icon: '📚', label: 'Etüt Yönetimi' }, // A) Eklendi
          { path: '/admin/sistem-analiz', icon: '◈', label: 'Sistem Analizi' },
          { path: '/admin/mufredat-takibi', icon: '📖', label: 'Müfredat Genel Bakış' },
        ]
      },
      {
        title: 'İletişim', items: [
          { path: '/admin/bildirimler', icon: '◉', label: 'Bildirimler', badge: true },
          { path: '/admin/toplu-mesaj', icon: '◐', label: 'Toplu Mesaj' },
          { path: '/admin/kullanicilar', icon: '▣', label: 'Tüm Kullanıcılar' },
          { path: '/admin/gonderilen-mesajlar', icon: '📲', label: 'Gönderilen Mesajlar' },
        ]
      },
      {
        title: 'Muhasebe', items: [
          { path: '/muhasebe/dashboard', icon: '💰', label: 'Muhasebe Paneli' },
          { path: '/muhasebe/crm', icon: '🎯', label: 'CRM — Adaylar' },
          { path: '/muhasebe/sozlesmeler', icon: '📋', label: 'Sözleşmeler' },
          { path: '/muhasebe/tahsilat', icon: '💳', label: 'Tahsilat' },
          { path: '/muhasebe/odeme-hatirlatmalari', icon: '📲', label: 'Ödeme Hatırlatmaları' },
          { path: '/muhasebe/stok', icon: '📦', label: 'Stok' },
          { path: '/muhasebe/planlanan-gelir', icon: '📈', label: 'Planlanan Gelir' },
          { path: '/muhasebe/planlanan-gider', icon: '📋', label: 'Planlanan Gider' },
          { path: '/muhasebe/raporlar', icon: '📊', label: 'Finansal Raporlar' },
        ]
      },
    ]
  },
  ogrenci_isleri: {
    color: 'var(--role-isleri)',
    label: 'Öğrenci İşleri',
    icon: '◈',
    sections: [
      {
        title: 'İşlemler', items: [
          { path: '/admin/dashboard', icon: '◈', label: 'Dashboard' },
          { path: '/admin/ogrenciler', icon: '◉', label: 'Öğrenciler' },
          { path: '/admin/kelebek', icon: '🦋', label: 'Sınav Oluştur' },
          { path: '/admin/denemeler', icon: '▦', label: 'Denemeler' },
          { path: '/admin/ogrenci-deneme-analiz', icon: '📈', label: 'Öğrenci Deneme Analiz' },
          { path: '/admin/etut-yonetimi', icon: '📚', label: 'Etüt Yönetimi' }, // B) Eklendi
          { path: '/admin/devamsizlik', icon: '📋', label: 'Yoklama Al / Düzenle' },
          { path: '/admin/mufredat-takibi', icon: '📖', label: 'Müfredat Takibi' },
          { path: '/admin/siniflar', icon: '▤', label: 'Sınıflar' },
          { path: '/admin/ders-programi', icon: '▨', label: 'Ders Programı' },
          { path: '/admin/bildirimler', icon: '◉', label: 'Bildirimler', badge: true },
          { path: '/admin/toplu-mesaj', icon: '◐', label: 'Toplu Mesaj' },
        ]
      },
    ]
  },
  ogretmen: {
    color: 'var(--role-ogretmen)',
    label: 'Öğretmen',
    icon: '◎',
    sections: [
      {
        title: 'Sınıfım', items: [
          { path: '/ogretmen/dashboard', icon: '◈', label: 'Dashboard' },
          { path: '/ogretmen/yoklama', icon: '◉', label: 'Yoklama' },
          { path: '/ogretmen/odevler', icon: '▦', label: 'Ödevler' },
          { path: '/ogretmen/program', icon: '▧', label: 'Ders Programım' },
          { path: '/ogretmen/mufredat', icon: '📖', label: 'Müfredat Takibi' },
          { path: '/ogretmen/denemeler', icon: '▨', label: 'Denemeler' },
          { path: '/ogretmen/ogrenci-deneme-analiz', icon: '📈', label: 'Öğrenci Deneme Analiz' },
          { path: '/ogretmen/etutlerim', icon: '📚', label: 'Etütlerim' }, // C) Eklendi
          { path: '/ogretmen/randevular', icon: '▤', label: 'Randevular' },
          { path: '/ogretmen/bildirimler', icon: '◉', label: 'Bildirimler', badge: true },
        ]
      },
    ]
  },
  rehber_ogretmen: {
    color: 'var(--role-rehber)',
    label: 'Rehber Öğretmen',
    icon: '◎',
    sections: [
      {
        title: 'Yönetim', items: [
          { path: '/rehber/dashboard', icon: '◈', label: 'Dashboard' },
          ...getCoreManagementMenuItems('rehber_ogretmen'),
        ]
      },
      {
        title: 'Rehberlik', items: [
          { path: '/rehber/denemeler', icon: '▨', label: 'Denemeler' },
          { path: '/rehber/ogrenci-deneme-analiz', icon: '📈', label: 'Öğrenci Deneme Analiz' },
          { path: '/rehber/turkiye-geneli-deneme-sonuclari', icon: '▥', label: 'Türkiye Geneli Denemeler' },
          { path: '/rehber/devamsizlik', icon: '📋', label: 'Yoklama Al / Düzenle' },
          { path: '/rehber/gorusmeler', icon: '◉', label: 'Görüşmeler' },
          { path: '/rehber/seans-olustur', icon: '📅', label: 'Öğrenci Seansı Oluştur' },
          { path: '/rehber/konular', icon: '📚', label: 'Konular' },
          { path: '/rehber/tekrarlar', icon: '🔁', label: 'Tekrarlar' },
          { path: '/rehber/programlar', icon: '▦', label: 'Çalışma Programları' },
          { path: '/rehber/etut-yonetimi', icon: '📚', label: 'Etüt Yönetimi' },
          { path: '/rehber/randevular', icon: '▤', label: 'Randevular' },
        ]
      },
      {
        title: 'İletişim', items: [
          { path: '/rehber/toplu-mesaj', icon: '◐', label: 'Toplu Mesaj' },
          { path: '/rehber/gonderilen-mesajlar', icon: '📲', label: 'Gönderilen Mesajlar' },
        ]
      },
    ]
  },
  veli: {
    color: 'var(--role-veli)',
    label: 'Veli',
    icon: '◍',
    sections: [
      {
        title: 'Takip', items: [
          { path: '/veli/dashboard', icon: '◈', label: 'Dashboard' },
          { path: '/veli/basari', icon: '◉', label: 'Başarı Takibi' },
          { path: '/veli/devamsizlik', icon: '▦', label: 'Devamsızlık' },
          { path: '/veli/etutler', icon: '📚', label: 'Etüt Takibi' }, // E) Eklendi
          { path: '/veli/bildirimler', icon: '◉', label: 'Bildirimler', badge: true },
        ]
      },
    ]
  },
  ogrenci: {
    color: 'var(--role-ogrenci)',
    label: 'Öğrenci',
    icon: '◉',
    sections: [
      {
        title: 'Öğrencim', items: [
          { path: '/ogrenci/dashboard', icon: '◈', label: 'Dashboard' },
          { path: '/ogrenci/odevler', icon: '📝', label: 'Ödevlerim' },
          { path: '/ogrenci/kelebek', icon: '🦋', label: 'Kelebek Sınavı' },
          { path: '/ogrenci/yoklama', icon: '◉', label: 'Devamsızlık Bilgisi' },
          { path: '/ogrenci/program', icon: '▧', label: 'Ders Programım' },
          { path: '/ogrenci/siralama', icon: '▦', label: 'Sıralama' },
          { path: '/ogrenci/etut-talep', icon: '▨', label: 'Etüt Talebi' },
          { path: '/ogrenci/randevu', icon: '📅', label: 'Randevu Oluştur' },
          { path: '/ogrenci/etutlerim', icon: '📚', label: 'Etütlerim' }, // F) Eklendi
          { path: '/ogrenci/calisma', icon: '▨', label: 'Çalışma Programım' },
          { path: '/ogrenci/bildirimler', icon: '◉', label: 'Bildirimler', badge: true },
        ]
      },
    ]
  },
  muhasebe: {
    color: 'var(--role-muhasebe)',
    label: 'Muhasebe',
    icon: '💰',
    sections: [
      {
        title: 'Yönetim', items: getCoreManagementMenuItems('muhasebe')
      },
      {
        title: 'Genel', items: [
          { path: '/muhasebe/dashboard', icon: '◈', label: 'Muhasebe Paneli' },
          { path: '/muhasebe/crm', icon: '🎯', label: 'CRM — Aday Takibi' },
          { path: '/muhasebe/sozlesmeler', icon: '📋', label: 'Sözleşmeler' },
          { path: '/muhasebe/sozlesme-analizleri', icon: '📈', label: 'Sözleşme Analizleri' },
          { path: '/muhasebe/tahsilat', icon: '💳', label: 'Tahsilat' },
          { path: '/muhasebe/odeme-hatirlatmalari', icon: '📲', label: 'Ödeme Hatırlatmaları' },
          { path: '/muhasebe/indirim-sablonlari', icon: '🏷️', label: 'İndirim Şablonları' },
        ]
      },
      {
        title: 'Stok & Satış', items: [
          { path: '/muhasebe/stok', icon: '📦', label: 'Stok Yönetimi' },
          { path: '/muhasebe/materyal-satis', icon: '🛒', label: 'Materyal Satışı' },
        ]
      },
      {
        title: 'Finans', items: [
          { path: '/muhasebe/giderler', icon: '📉', label: 'Giderler' },
          { path: '/muhasebe/planlanan-gelir', icon: '📈', label: 'Planlanan Gelir' },
          { path: '/muhasebe/planlanan-gider', icon: '📋', label: 'Planlanan Gider' },
          { path: '/muhasebe/kasa', icon: '🏦', label: 'Kasa & Banka' },
        ]
      },
      {
        title: 'Personel', items: [
          { path: '/muhasebe/maaslar', icon: '💼', label: 'Maaş / Hakediş' },
          { path: '/muhasebe/ek-ders', icon: '🏫', label: 'Ek Ders Takibi' },
        ]
      },
      {
        title: 'Raporlar', items: [
          { path: '/muhasebe/raporlar', icon: '📊', label: 'Finansal Raporlar' },
        ]
      },
    ]
  },
};

export default function Sidebar({ collapsed, onToggle, unreadCount = 0 }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const config = ROLE_CONFIGS[user?.rol] || ROLE_CONFIGS.ogrenci;

  // Sayfa değiştiğinde mobil menüyü kapat
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const initials = user
    ? `${user.ad?.[0] || ''}${user.soyad?.[0] || ''}`.toUpperCase()
    : '?';

  const handleLogout = () => {
    logout();
    navigate('/login');
    toast.success('Güvenli çıkış yapıldı');
  };

  return (
    <>
      <div className="mobile-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
          {/* Logo görseli */}
          <img
            src={asderLogo}
            alt="ASDER Sistem Logo"
            style={{ width: '64px', height: '64px', objectFit: 'contain' }}
          />
          {/* Yeni Başlık */}
          <div style={{
            fontFamily: 'var(--font-ui)',
            fontWeight: 800,
            fontSize: '1.1rem',
            color: 'var(--text-blue)',
            letterSpacing: '-0.02em'
          }}>
            ASDER Sistem
          </div>
        </div>
        <button className="mobile-toggle" onClick={() => setIsMobileOpen(!isMobileOpen)}>
          {isMobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Mobil Karartma Overlay */}
      {isMobileOpen && (
        <div className="sidebar-overlay" onClick={() => setIsMobileOpen(false)} />
      )}

      <nav className={`sidebar ${collapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-show' : ''}`}>
        {/* Logo Bölümü */}
        {/* Logo Bölümü */}
        <div className="sidebar-logo" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1px',
          padding: collapsed && !isMobileOpen ? '20px 0' : '25px 20px',
          justifyContent: collapsed && !isMobileOpen ? 'center' : 'flex-start'
        }}>
          <div style={{
            width: collapsed && !isMobileOpen ? 42 : 54,
            height: collapsed && !isMobileOpen ? 42 : 54,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.08))'
          }}>
            <img
              src={asderLogo}
              alt="Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>

          {(!collapsed || isMobileOpen) && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="sidebar-logo-text" style={{
                fontSize: '1.3rem', // Yazı boyutu büyütüldü
                fontWeight: 900,
                color: 'var(--text-blue)',
                lineHeight: 1,
                letterSpacing: '-0.02em'
              }}>
                ASDER Sistem
              </div> 
              <div className="sidebar-logo-sub" style={{
                fontSize: '0.6rem',
                color: 'var(--text-muted)',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                marginTop: 4
              }}>
                Yönetim Paneli
              </div>
            </div>
          )}
        </div>
        {/* Navigation */}
        <div className="sidebar-nav">
          {config.sections.map((section, si) => (
            <div key={si}>
              <div className="sidebar-section-title">{section.title}</div>
              {section.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                  title={collapsed ? item.label : undefined}
                >
                  <div className="nav-icon" style={{ fontSize: '1.1rem', fontFamily: 'monospace' }}>
                    {item.icon}
                  </div>
                  <span className="nav-label">{item.label}</span>
                  {item.badge && unreadCount > 0 && (
                    <span className="nav-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                  )}
                </NavLink>
              ))}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sidebar-footer">
          {!collapsed && (
            <div style={{
              padding: '10px 10px',
              marginBottom: '8px',
              borderRadius: 'var(--r-md)',
              background: 'var(--accent-dim)',
              border: '1px solid var(--accent-border)',
            }}>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 4 }}>
                Rol
              </div>
              <div style={{ fontSize: '0.8rem', fontWeight: 700, color: config.color }}>
                {config.label}
              </div>
            </div>
          )}

          <NavLink to="/ayarlar" className="nav-item">
            <div className="nav-icon">⚙</div>
            <span className="nav-label">Ayarlar</span>
          </NavLink>

          <div className="sidebar-user" onClick={handleLogout} style={{ marginTop: 4 }}>
            <div className="user-avatar">{initials}</div>
            {!collapsed && (
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{
                  fontSize: '0.82rem',
                  fontWeight: 600,
                  color: '#ADC8FF',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {user?.ad} {user?.soyad}
                </div>
                <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>Çıkış yap →</div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}
